"use client";
import React from "react";
import { ENTITY_TYPE, USER_ROLES } from "~/constants";
import { getTableHeadDateTime, TableCellDateTime } from "~/components/table/cells/TableCellDateTime.jsx";
import { TurnrTableCell, TurnrTableRow } from "~/components/table/TurnrTableSmart.jsx";
import { TableCellActions } from "~/components/table/cells/TableCellActions.jsx";
import EntityActionsDotsMenu from "~/components/entityAction/EntityActionsDotsMenu.jsx";
import { humanReadableDateTime } from "rylak-common";
import { getReadableUserType } from "~/cores/userCore";
import EntityActionFilterForm from "~/components/entityAction/EntityActionFilterForm.jsx";
import { CopyClickableIcon } from "~/components/copyText/CopyClickableIcon.jsx";
import { COLORS } from "rylak-common/src/constants.js";

function getTableHeadData() {
    return {
        items: [
            {
                id: "email",
                label: "Email",
                defaultSortedBy: true,
            },
            {
                id: "",
                label: "Role",
                sortable: false,
                hide: "xs",
            },
            {
                id: "userType",
                label: "User type",
                defaultSortDirection: "desc",
                sortable: false,
                hide: "sm",
            },
            {
                id: "lastLoginAt",
                label: "Last login",
                arrowsReversed: true,
                defaultSortDirection: "desc",
                hide: "sm",
            },
            getTableHeadDateTime({ hide: "lg" }),
            {
                id: "dotMenu",
                label: "",
            },
        ].filter((v) => v),
    };
}

function TableContent({ appProps, entitiesPaginatedService, reFetchEntitiesPaginated, ...rest }) {
    return entitiesPaginatedService?.data?.content?.map((user) => {
        let { id, email, displayName, createdAt, lastLoginAt, role } = user;

        const userRoleData = USER_ROLES[role];
        return (
            <TurnrTableRow key={id} {...rest}>
                <TurnrTableCell>
                    <div style={{ marginTop: "3px", marginBottom: "3px", textWrap: "wrap", wordBreak: "break-word" }}>
                        <CopyClickableIcon>{displayName}</CopyClickableIcon>

                        <div style={{ color: COLORS.WEAK_TEXT, textWrap: "wrap" }}>
                            <CopyClickableIcon textToCopy={email}>
                                <div>{email}</div>
                            </CopyClickableIcon>
                        </div>
                    </div>
                </TurnrTableCell>
                <TurnrTableCell tight>
                    <b style={{ color: userRoleData?.color, textWrap: "nowrap" }}>{userRoleData?.name}</b>
                </TurnrTableCell>
                <TurnrTableCell fullWidth>
                    <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                        {getReadableUserType({
                            user,
                            useDisplayName: false,
                        })}
                    </div>
                </TurnrTableCell>
                <TableCellDateTime dateTime={lastLoginAt} contentFn={() => (lastLoginAt ? humanReadableDateTime({ dateTime: lastLoginAt }) : "Never")} />
                <TableCellDateTime dateTime={createdAt} />
                <TableCellActions>
                    <EntityActionsDotsMenu entity={user} appProps={appProps} onSuccess={reFetchEntitiesPaginated} />
                </TableCellActions>
            </TurnrTableRow>
        );
    });
}

export default function AdminPageUsersTab({ appProps }) {
    return (
        <EntityActionFilterForm appProps={appProps} entityType={ENTITY_TYPE.USER} tableHeadData={getTableHeadData()}>
            <TableContent appProps={appProps} />
        </EntityActionFilterForm>
    );
}
